// extracted by mini-css-extract-plugin
export default {"footer":"c2MBid","tags":"BflrcU","tagIcon":"tlp6M2"};